export default {
  getLoading: ({ state }) => state.loading,
  getToastOptions: ({ state }) => state.toast,
  getUser: ({ user }) => user.currentUser,
}



// WEBPACK FOOTER //
// ./client/vuex/getters.js